import type { CommonConsumer } from '@makemydeal/dr-platform-types';
import { Actions } from '../actionTypes/actionTypes';
import type { ParticipantRole } from '@makemydeal/dr-sales-checkin-types';
import { ConversationTypeEnum, CustomerCardState, DeepLinks } from '@makemydeal/dr-sales-checkin-types';

export const setCoBuyer = (coBuyer: CommonConsumer) => {
    return {
        type: Actions.SET_CO_BUYER,
        payload: { coBuyer }
    };
};

export const removeCoBuyer = () => {
    return {
        type: Actions.REMOVE_CO_BUYER,
        payload: {}
    };
};

export const setSelectedCustomer = (customer: CommonConsumer) => {
    return {
        type: Actions.SET_SELECTED_CUSTOMER,
        payload: { customer }
    };
};

/**
 * Merges the edited participant (buyer or co-buyer) into SCI state after the Deal Central customer
 * card has already persisted to the deal via its participants call.
 *
 * This action is intentionally NOT handled by the middleware, so it refreshes local state without
 * triggering a second (redundant) deals PUT — unlike `updateStateCustomer` (`UPDATE_CURRENT_CUSTOMER`).
 *
 * `subTab`: the sub-tab visible when Save was pressed.
 */
export const updateParticipantDetails = (participant: ParticipantRole, customer: CommonConsumer, subTab?: string) => {
    return {
        type: Actions.UPDATE_PARTICIPANT_DETAILS,
        payload: { participant, customer, subTab }
    };
};

export const addCoBuyer = (isCoBuyer: boolean, customerCardState: CustomerCardState) => {
    return {
        type: Actions.ADD_CO_BUYER,
        payload: { isCoBuyer, customerCardState }
    };
};

export const viewCustomerInfo = (customerCardState: CustomerCardState) => {
    return {
        type: Actions.VIEW_CUSTOMER_INFO,
        payload: { isCoBuyer: false, customerCardState }
    };
};

export const viewCoBuyerInfo = (customerCardState: CustomerCardState) => {
    return {
        type: Actions.VIEW_CUSTOMER_INFO,
        payload: { isCoBuyer: true, customerCardState }
    };
};

/**
 * Opens the customer card slideout directly on the OCC Customer Inbox tab (Manager View parity).
 * Reuses the VIEW_CUSTOMER_INFO wiring so `commonReducer` seeds the card state + options and
 * `customerReducer` records the buyer/co-buyer context.
 */
export const viewCustomerInbox = (isCoBuyer = false) => {
    return {
        type: Actions.VIEW_CUSTOMER_INFO,
        payload: {
            isCoBuyer,
            customerCardState: CustomerCardState.INBOX,
            options: {
                defaultTab: 'inbox',
                occDefaultTab: ConversationTypeEnum.TEXT,
                message: DeepLinks.Invalid
            }
        }
    };
};

export const cancelUpdateCustomer = () => {
    return {
        type: Actions.CANCEL_UPDATE_CUSTOMER,
        payload: {}
    };
};
